import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import ValidationEngine from 'devextreme/ui/validation_engine';
import { BAD_REQUEST, NOT_FOUND } from 'http-status-codes';
import { of } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
import { PatientService } from 'src/app/modules/shared/services/patient.service';
import { environment } from '../../../../environments/environment';
import { RegistrationRequest, User } from '../../../shared/models/fusion-auth';
import { FusionAuthManagementService, FusionAuthService } from '../../../shared/services/fusion-auth';
import { AppInfoService } from '../../../shared/services/general';

@Component({
    selector: 'app-patient-sign-up',
    templateUrl: './patient-sign-up.component.html',
    styleUrls: ['./patient-sign-up.component.scss'],
})
export class PatientSignUpComponent {
    public patientSignUpForm: UntypedFormGroup;
    public isLoading = false;
    public user: User = {} as User;

    constructor(
        private fb: UntypedFormBuilder,
        private router: Router,
        private fusionAuth: FusionAuthService,
        private applicationInfo: AppInfoService,
        private patientService: PatientService,
        private fusionAuthManagement: FusionAuthManagementService) {
        this.patientSignUpForm = this.fb.group({
            lastName: new UntypedFormControl('', [Validators.required]),
            firstName: new UntypedFormControl('', [Validators.required]),
            birthDate: new UntypedFormControl('', [Validators.required]),
            patientId: new UntypedFormControl('', [Validators.required]),
            email: new UntypedFormControl('', [Validators.required]),
        });
    }

    public get Logo(): string {
        return this.applicationInfo.logo;
    }

    public submit() {
        const patientSignUpValidation = ValidationEngine.validateGroup('patientSignUpForm');
        if (patientSignUpValidation.isValid) {
            this.isLoading = true;
            const lastName = this.patientSignUpForm.get('lastName')?.value.toUpperCase();
            const firstName = this.patientSignUpForm.get('firstName')?.value.toUpperCase();
            const birthDate = this.patientSignUpForm.get('birthDate')?.value;
            const patientId = this.patientSignUpForm.get('patientId')?.value;
            const email = this.patientSignUpForm.get('email')?.value;

            this.user = {
                lastName,
                firstName,
                birthDate,
                email,
                username: email.split('@')[0] + (Math.floor(Math.random() * (99999 - 10000)) + 10000),
                data: {},
                active: true,
            } as any;

            const request: RegistrationRequest = {
                user: this.user,
                registration: {
                    applicationId: environment.fusionAuth.applicationId,
                    roles: [],
                    username: this.user.username,
                    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                },
            };

            this.fusionAuthManagement
                .createPatientUser(patientId, request)
                .pipe(
                    take(1),
                    tap(() => (this.isLoading = false)),
                    catchError(err => {
                        this.isLoading = false;
                        if (err.status === NOT_FOUND) {
                            notify('No patient could be match in our database', 'error', 3000);
                        } else if (err.status === BAD_REQUEST) {
                            notify('Email in use', 'error', 3000);
                        } else {
                            notify(err.message, 'error', 3000);
                        }
                        return of(null);
                    }))
                .subscribe(async response => {
                    if (response) {
                        await this.router.navigateByUrl('/login');
                        notify('A notification has been sent to created user\'s email.', 'success', 3000);
                    }
                });
        }
    }

}

